import { unitConversion } from '@/pages/dashboard/utils/utils';
import _ from 'lodash-es';

// 数组arr中匹配单个字符串str的方法，传入数组arr支持格式[{},{}],
function searchStr(str: string, arr: string | any[]) {
  let newList = [];
  // 要匹配字符串的首个字符
  let startChar = str.charAt(0);
  // 要匹配字符串的字符长度
  let strLength = str.length;
  for (let i = 0; i < arr.length; i++) {
    // 默认数组arr中对象arr[i]不存在str
    let isExist = false;
    let obj = arr[i];
    for (let key in obj) {
      if (typeof obj[key] === 'function') {
        obj[key]();
      } else {
        let keyValue = '';
        // 获取arr[i][key]的值
        if (obj[key] !== null && typeof obj[key] === 'string') {
          keyValue = obj[key];
        } else if (obj[key] !== null && typeof obj[key] !== 'string') {
          keyValue = JSON.stringify(obj[key]);
        }
        // arr[i][key]中的各个位置的字符与str的0位置字符startChar对比如果相等，
        // 在arr[i][key]中从j位置截取与str长度相同的字符，对比是否相等
        for (let j = 0; j < keyValue.length; j++) {
          // 把原有数据转化为小写，输入数据也转化为纯小写，实现模糊匹配,如区分大小写，可删除toLowerCase()
          if (keyValue.charAt(j).toLowerCase() === startChar.toLowerCase()) {
            if (
              keyValue.substring(j).substring(0, strLength).toLowerCase() ===
              str.toLowerCase()
            ) {
              // 模糊匹配到的字符存在表示arr[i]中存在str
              isExist = true;
              break;
            }
          }
        }
      }
    }
    // 当arr[i]中存在str时，把arr[i]放入一个新数组
    if (isExist === true) {
      newList.push(obj);
    }
  }
  // 最后返回这个新数组
  return newList;
}
export default searchStr;
type IKey = 'investments' | 'investors' | 'fundingRounds' | 'acquisitions';

type InvestmentsName = 'organization_name' | 'funding_round' | 'money_raised';

type InvestorsName =
  | 'investor'
  | 'is_lead_investor'
  | 'funding_round_identifier_value'
  | 'partner_identifiers_value';

type FundingRounds =
  | 'announced_on'
  | 'lead_investor'
  | 'money_raised'
  | 'num_investors'
  | 'transaction_name';

type Acquisitions =
  | 'acquiree_name'
  | 'announces_date'
  | 'price'
  | 'transaction_name';

const INVESTMENTS_NAME: InvestmentsName[] = [
  'organization_name',
  'funding_round',
  'money_raised',
];
const INVESTORNAME: InvestorsName[] = [
  'investor',
  'funding_round_identifier_value',
  'partner_identifiers_value',
];

const FUNDING_ROUNDS: FundingRounds[] = ['transaction_name', 'lead_investor'];

const ACQUISITIONS: Acquisitions[] = ['acquiree_name', 'transaction_name'];

export const checkListFn = <T extends IKey>(
  arr: { [key in string]: any },
  key: T,
) => {
  // 每一列需要转化的name,
  const mapList = {
    investments: INVESTMENTS_NAME,
    investors: INVESTORNAME,
    fundingRounds: FUNDING_ROUNDS,
    acquisitions: ACQUISITIONS,
  }[key];
  // 每一列的需要清空的值
  const mapListDel = ['-'] as const;

  if (_.isEmpty(arr)) return [];
  return mapList.map((task, index) => {
    const list = _.unionBy(arr, task).map((item) => {
      // 需要清空的值
      if (mapListDel.includes(item[task])) {
        return;
      }
      // 需要转化的
      if (!isNaN(Number(item[task]))) {
        return {
          name: item[task],
          text: unitConversion(item[task]),
        };
      }
      return {
        name: item[task],
        text: item[task],
      };
    });
    return _.compact(list);
  });
};
